/* eslint react/no-multi-comp: 0 */

import React from 'react';
import { Section, preloader } from 'spectacle-ppa';

import headingSlide from '../../baseSlides/headingSlide';
import videoSlide from '../../baseSlides/videoSlide';
import balloonSlide from '../../baseSlides/balloonSlide';

import ianHeadshotSmile from '../../images/characters/ian_headshot_smile.png';
import ianSaraSide from '../../images/characters/ian_sara_side.png';
import ianSaraLeanSmile from '../../images/characters/ian_sara_lean_smile.png';
import ianSide from '../../images/characters/ian_side.png';
import saraSurprised from '../../images/characters/sara_surprised.png';
import saraTwistHandsOutHeyhey from '../../images/characters/sara_twist_hands_out_heyhey.png';
import ianPointingUp from '../../images/characters/ian_pointing_up.png';
import ianPointingLeft from '../../images/characters/ian_pointing_left.png';
import ianPointingDown from '../../images/characters/ian_pointing_down.png';
import saraSmile from '../../images/characters/sara_smile.png';
import saraHumph from '../../images/characters/sara_humph.png';
import ianSaraLeanQuestioning from '../../images/characters/ian_sara_lean_questioning.png';

import MarkdownScript from 'helpers/markdownScript';
import markdownFileLevel1 from './level1_drawing.md';
import markdownFileLevel2 from './level2_writing.md';

const levels = {
  '1': { md: new MarkdownScript(markdownFileLevel1) },
  '2': { md: new MarkdownScript(markdownFileLevel2) }
};

export function preloadClassActivity () {
  preloader([
    ianHeadshotSmile,
    ianSaraSide,
    ianSaraLeanSmile,
    ianSide,
    saraSurprised,
    saraTwistHandsOutHeyhey,
    ianPointingUp,
    ianPointingLeft,
    ianPointingDown,
    saraSmile,
    saraHumph,
    ianSaraLeanQuestioning
  ]);
}

function introVideo (level, regionData) {
  const md = levels[level].md;
  return (
    videoSlide({
      id: 'intro-video',
      notes: md.getSubSectionAsHtml('Intro Video', 'Notes', false, regionData),
      youTubeId: md.getSectionMetadata('Intro Video', 'YouTube', regionData)
    })
  );
}

function sizzle (level, regionData) {
  const md = levels[level].md;
  return (
    balloonSlide({
      id: 'sizzle',
      characterSide: 'right',
      characterImage: ianSaraSide,
      notes: md.getSubSectionAsHtml('Sizzle', 'Notes', false, regionData),
      html: md.getSubSectionAsHtml('Sizzle', 'Content', false, regionData)
    })
  );
}

function instructions (level, regionData) {
  const md = levels[level].md;
  return (
    balloonSlide({
      id: 'instructions',
      characterSide: 'right',
      characterImage: ianSaraLeanSmile,
      notes: md.getSubSectionAsHtml('Instructions', 'Notes', false, regionData),
      html: md.getSubSectionAsHtml('Instructions', 'Content', false, regionData)
    })
  );
}

function level1 (regionData) { // floorplan
  const level = '1';
  return (

    <Section id={`class-activity-${level}`}>

      {/* Sizzle */}
      {sizzle(level, regionData)}

      {/* Intro Video */}
      {introVideo(level, regionData)}

      {/* Instructions */}
      {instructions(level, regionData)}

    </Section>
  );
}

function level2 (regionData) { // Draw Energy
  const level = '2';
  const md = levels[level].md;
  return (

    <Section id={`class-activity-${level}`}>

      {/* Sizzle */}
      {sizzle(level, regionData)}

      {/* Instructions */}
      {instructions(level, regionData)}

      {/* Write poem */}
      {balloonSlide({
        id: 'write-poem',
        characterSide: 'left',
        characterImage: saraTwistHandsOutHeyhey,
        notes: md.getSubSectionAsHtml('Write Poem', 'Notes', false, regionData),
        html: md.getSubSectionAsHtml('Write Poem', 'Content', false, regionData)
      })}

      {/* Scoring Reminder */}
      {balloonSlide({
        id: 'scoring-reminder',
        characterSide: 'left',
        characterImage: ianPointingUp,
        notes: md.getSubSectionAsHtml('Scoring Reminder', 'Notes', false, regionData),
        html: md.getSubSectionAsHtml('Scoring Reminder', 'Content', false, regionData)
      })}

    </Section>
  );
}

function classActivitySection ({ level, subActivity, regionData }) {
  switch (`${level}${subActivity ? subActivity : ''}`) {
  case '1':
    return level1(regionData);
  case '2':
    return level2(regionData);
  default:
    return headingSlide({ heading: 'Unknown' });
  }
}

export default classActivitySection;



// WEBPACK FOOTER //
// ./programs/h2whoaHybrid/sections/30_classActivity/classActivitySection.jsx